module.exports = __webpack_public_path__ + "img/popup-bg-small.1dfbf7d1.png";